import { W as WuiInput$1, d as defineCustomElement$1 } from './p-BYuH_pKM.js';

const WuiInput = WuiInput$1;
const defineCustomElement = defineCustomElement$1;

export { WuiInput, defineCustomElement };
